"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NoItemsIndicatorStyled = require("./NoItemsIndicator-styled.js");
var _FileIcon = _interopRequireDefault(require("calcite-ui-icons-react/FileIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NoItemsIndicator = function NoItemsIndicator() {
  return /*#__PURE__*/_react.default.createElement(_NoItemsIndicatorStyled.StyledNoItemsIndicator, null, /*#__PURE__*/_react.default.createElement(_FileIcon.default, {
    size: 160,
    color: "#ccc"
  }), /*#__PURE__*/_react.default.createElement(_NoItemsIndicatorStyled.StyledNTextWrapper, null, /*#__PURE__*/_react.default.createElement(_NoItemsIndicatorStyled.StyledH1, null, "No items yet."), /*#__PURE__*/_react.default.createElement(_NoItemsIndicatorStyled.StyledP, null, "No items found that meet your criteria. Try changing your search term or clearing some filters to show more items.")));
};
var _default = NoItemsIndicator;
exports.default = _default;